<main  class="container-lg">
  <section class="p-4" *ngIf="availableProducts?.length > 0">
    <ng-container *ngIf="!productSelected">
      <h1>Productos Comprados</h1>
      <div class="products-container">
        <div *ngFor="let product of availableProducts">
          <div class="card" style="width: fit-content; margin: 0 auto; height:500px; width:300px;">
            <img class="card-img-top card-image" src="{{product?.productImage ?? notFoundImagePath}}" alt="Card image cap">
            <div class="card-body" style="overflow-y: scroll;">
              <h5 class="card-title">{{product?.productName ?? "Nombre del producto"}}</h5>
              <p class="card-text">Disponibles: {{product?.availableQuantity}}</p>
              <p class="card-text">{{product?.productDescription ?? "Descripción del producto"}}</p>
              <!--Order Detail Properties-->
              <p *ngIf="product?.hasDentalMonitoring || product?.addedDentalMonitoring" class="mt-2">Este producto cuenta con <span class="dm-text">Dental Monitoring</span></p>
              <p *ngIf="product?.addedIsComplexCase" class="mt-2">Este producto cuenta con <span class="dm-text">Caso Complejo</span></p>
              <p *ngIf="product?.productExtraAlignersQuantity > 0" class="mt-2">Este producto cuenta con <span class="dm-text">{{product?.productExtraAlignersQuantity}} Alineadores adicionales</span></p>
              <!--Order Detail Properties-->
              <button mat-button class="primary-button lh-1 w-100 mt-2" (click)="onSelectProduct(product)">Seleccionar <mat-icon>chevron_right</mat-icon></button>
            </div>
            <div class="card-footer text-muted" *ngIf="!product.productHasUnlimitedAligners">
              Número de alineadores: {{product?.productAlignersQuantity ?? 0}}
            </div>
            <div class="card-footer text-muted" *ngIf="product.productHasUnlimitedAligners">
              Número de alineadores: Ilimitados
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="productSelected">
      <h2>Producto Seleccionado</h2>
      <div class="card responsive-card" style=" margin: 0 auto;">
        <img style="object-fit: contain;" class="card-img-top card-image" src="{{productSelected?.productImage ?? notFoundImagePath}}" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">{{productSelected?.productName ?? "Nombre del producto"}}</h5>
          <p class="card-text">Disponibles: {{productSelected?.availableQuantity}}</p>
          <p class="card-text">{{productSelected?.productDescription ?? "Descripción del producto"}}</p>
          <!--Order Detail Properties-->
          <p *ngIf="productSelected?.hasDentalMonitoring || product?.addedDentalMonitoring" class="mt-2">Este producto cuenta con <span class="dm-text">Dental Monitoring</span></p>
          <p *ngIf="productSelected?.addedIsComplexCase" class="mt-2">Este producto cuenta con <span class="dm-text">Caso Complejo</span></p>
          <p *ngIf="productSelected?.productExtraAlignersQuantity > 0" class="mt-2">Este producto cuenta con <span class="dm-text">{{productSelected?.productExtraAlignersQuantity}} Alineadores adicionales</span></p>
          <!--Order Detail Properties-->
        </div>
        <div class="card-footer text-muted" *ngIf="!productSelected.productHasUnlimitedAligners">
          Número de alineadores: {{productSelected?.productAlignersQuantity ?? 0}}
        </div>
        <div class="card-footer text-muted" *ngIf="productSelected.productHasUnlimitedAligners">
          Número de alineadores: Ilimitadoss
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-2">
        <button mat-button class="btn-danger" (click)="productSelected = null">Cancelar <mat-icon>close</mat-icon></button>
        <button mat-button class="btn-success" (click)="onConfirmProductSelected()">Confirmar <mat-icon>check</mat-icon> </button>
      </div>
    </ng-container>
  </section>
  <section *ngIf="availableProducts?.length == 0">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-notify.svg" alt="Notificación imagen">
      <h2>No cuentas aún con ningún producto disponible para asignarlo a este caso.</h2>
    </div>
  </section>
</main>
